import { LivestreamApproachingType } from 'src/models/Campaigns/livestream';
import { ApiFunctionType, httpGetCancellable } from 'src/utils/http';

export const apiGetLivestreamBannerInfo: ApiFunctionType<{ campaignUrl: string | number }, LivestreamApproachingType> =
  httpGetCancellable('/liveStreamInformation/loadLiveStreamBannerInfo');
